(function () {
  function resolveMainProductSectionId(sectionId) {
    if (sectionId) {
      return sectionId;
    }

    var mainEl = document.querySelector('[data-andala-main-product-section-id]');

    return mainEl ? mainEl.getAttribute('data-andala-main-product-section-id') || '' : '';
  }

  function getPurchaseApi(sectionId) {
    var store = window.AndalaMainProductPurchase;
    var resolvedId = resolveMainProductSectionId(sectionId);

    if (!store) {
      return null;
    }

    if (resolvedId && store[resolvedId]) {
      return store[resolvedId];
    }

    return store.active || null;
  }

  function addOneTimeVariant(root, button, variantId) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var redirectToCart = root.getAttribute('data-redirect-to-cart') === 'true';
    var payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };

    if (!redirectToCart && cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      }).join(',');
      payload.sections_url = window.location.pathname;

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(button);
      }
    }

    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || 'cart_add_failed');
        }

        if (redirectToCart) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (cart && response.sections && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }

          cart.renderContents(response);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'ru-pack-grid-v2',
              productVariantId: variantId,
              cartData: response,
            });
          }

          return;
        }

        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
  }

  function waitForPurchaseApi(sectionId, attempts) {
    var remaining = typeof attempts === 'number' ? attempts : 40;

    return new Promise(function (resolve, reject) {
      function tick() {
        var api = getPurchaseApi(sectionId);

        if (api && typeof api.selectAndAdd === 'function') {
          resolve(api);
          return;
        }

        remaining -= 1;

        if (remaining <= 0) {
          reject(new Error('purchase_api_unavailable'));
          return;
        }

        setTimeout(tick, 150);
      }

      tick();
    });
  }

  function initSection(root) {
    if (!root || root.dataset.packGridReady === 'true') {
      return;
    }

    root.dataset.packGridReady = 'true';

    var sectionId = root.getAttribute('data-main-product-section-id') || '';
    var message = root.querySelector('[data-pack-grid-message]');
    var buttons = root.querySelectorAll('[data-pack-grid-add]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        var variantId = button.getAttribute('data-variant-id');
        var purchaseOption = button.getAttribute('data-purchase-option');

        if (!variantId && !purchaseOption) {
          return;
        }

        button.classList.add('is-loading');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');

        if (message) {
          message.hidden = true;
          message.textContent = '';
        }

        var addPromise;

        if (variantId) {
          addPromise = addOneTimeVariant(root, button, variantId);
        } else {
          var redirectToCart = root.getAttribute('data-redirect-to-cart') === 'true';

          addPromise = waitForPurchaseApi(sectionId).then(function (api) {
            return api.selectAndAdd(purchaseOption, {
              redirectToCart: redirectToCart,
              sourceElement: button,
            });
          });
        }

        addPromise
          .catch(function () {
            if (message) {
              message.hidden = false;
              message.textContent =
                root.getAttribute('data-error-message') ||
                'No se pudo añadir al carrito. Prueba desde el formulario de compra.';
            }
          })
          .finally(function () {
            button.classList.remove('is-loading');
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ru-pack-grid-v2]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;

    if (!section) {
      return;
    }

    var root = section.querySelector('[data-ru-pack-grid-v2]');

    if (root) {
      root.dataset.packGridReady = 'false';
      initSection(root);
    }
  });
})();
